module.exports = __webpack_public_path__ + "1182d002b72b114061d9a2617c782c33.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-regular-webfont.eot
// module id = 432
// module chunks = 0